import request from '@/utils/request'

const prizeURL = {
  List: '/prize/list',
  Detail: '/prize/view',
  Update: '/prize/update',
  Create: '/prize/create',
  UpdateState: '/prize/status-update'
}

// 奖品列表
export function getListPrize (data) {
  return request({
    url: prizeURL.List,
    method: 'post',
    data
  })
}

// 奖品详情
export function getDetailPrize (data) {
  return request({
    url: prizeURL.Detail,
    method: 'post',
    data
  })
}

// 奖品更新
export function getUpdatePrize (data) {
  return request({
    url: prizeURL.Update,
    method: 'post',
    data
  })
}

// 奖品创建
export function createPrize (data) {
  return request({
    url: prizeURL.Create,
    method: 'post',
    data
  })
}

// 奖品状态更新
export function updateStatePrize (data) {
  return request({
    url: prizeURL.UpdateState,
    method: 'post',
    data
  })
}

export default {
  createPrize,
  getListPrize,
  getDetailPrize,
  getUpdatePrize,
  updateStatePrize
}
